import { useTranslation } from 'react-i18next'

import { MapPinIcon } from '@phosphor-icons/react'

import { CheckboxOptionCard } from '@reveni-io/reveni-ui'

import { restrictsExchangeAddressInputName } from './constants'

const ExchangeAddressRestrictionConfiguration = ({ onChange, config }) => {
  const { t } = useTranslation()

  const isRestrictedByCarrierService = !!config?.carrier_service?.restricts_exchange_address
  const isRestricted = isRestrictedByCarrierService || !!config?.restricts_exchange_address

  const restrictionDescription = isRestrictedByCarrierService
    ? t(
        'El servicio logístico seleccionado requiere que los clientes usen la misma dirección para su devolución y su cambio.'
      )
    : t(
        'Los productos de cambio se entregarán en la misma dirección que la devolución — no se permitirá una dirección de entrega distinta.'
      )

  const handleChange = checked => onChange({ restricts_exchange_address: checked })

  return (
    <CheckboxOptionCard
      icon={<MapPinIcon size={24} weight="thin" />}
      title={t('Restringir la entrega del cambio a la dirección de devolución')}
      description={restrictionDescription}
      name={restrictsExchangeAddressInputName}
      selected={isRestricted}
      disabled={isRestrictedByCarrierService}
      onChange={handleChange}
    />
  )
}

export default ExchangeAddressRestrictionConfiguration
